export default {
  name: "设备分类",
  children: [
    {
      menuId: 5,
      name: "全部设备",
      url: "allequpt",
      isShow: true,
    },
    {
      menuId: 1,
      name: "公司设备",
      url: "centralequpt",
    },
    {
      menuId: 2,
      name: "共享设备",
      url: "shareequpt",
    },
    {
      menuId: 3,
      name: "院内设备",
      url: "hosequpt",
    },
    {
      menuId: 4,
      name: "外部资源",
      url: "outresources",
    },
  ],
};
